import React from 'react';
import styles from './InputField.module.css';

const InputField = (props) => {
    return <input className={[styles.input, styles[props.id]].join(' ')} 
                  value={props.value}
                  key={props.id}
                  onChange={props.onChange}
                  maxLength={10}/>;
}
export default InputField;